import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isCrawler)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "mapElement",
        class: _normalizeClass(["map hide-overflow", { loading: _ctx.loading }])
      }, [
        _createElementVNode("div", {
          style: {"position":"absolute","background-color":"transparent","width":"100%","height":"100%","z-index":"1000","display":"none"},
          class: _normalizeClass({ showScrolling: _ctx.showScrolling })
        }, null, 2)
      ], 2))
    : _createCommentVNode("", true)
}